import { render, staticRenderFns } from "./fda.vue?vue&type=template&id=1a1c1cfe"
import script from "./fda.vue?vue&type=script&lang=js"
export * from "./fda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports